export default __webpack_public_path__ + "icon_car.48f9227fcbb5fa838a7caf5695af30c6.svg";